import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useNavigateLocale } from "@/hooks/use-navigate-locale";
import { useAuth } from "react-oidc-context";
import { useLogin } from "@/features/authentication";
import TameeniLoaderOverlay from "./loader/tameeni-loader-overlay";
import { Button } from "@tameeni/ui";
export const protectedRoutes = [
  "passport-info",
  "traveler-info",
  "quote-list",
  "summary-and-payment",
  "payment",
  "success",
  "user-account",
];
export default function ProtectedRoutesErrorContainer({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth();
  const { signIn } = useLogin();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const navigateLocale = useNavigateLocale();
  const locale = pathname.startsWith("/en") ? "en" : "ar";
  const [searchParams] = useSearchParams();
  const isProtected = !!protectedRoutes.find(route => pathname.includes(route));
  let status: "loading" | "unauthenticated" | "authenticated" = "authenticated";
  if (isLoading) {
    status = "loading";
  } else if (!isAuthenticated) {
    status = "unauthenticated";
  }

  if (status === "loading") {
    return <TameeniLoaderOverlay transparent={false} />;
  }

  if (status == "unauthenticated" && isProtected) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-2">
        <h1 className="text-h1">{t("common.error.unauthenticated")}</h1>
        <p className="text-center text-s1 text-slate-500">
          {t("common.error.unauthenticated_desc")}
        </p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          <Button
            className="w-full"
            onClick={() => {
              const currentUrl =
                pathname +
                (searchParams.toString() ? `?${searchParams.toString()}` : "");
              const params = new URLSearchParams(
                searchParams?.toString() ?? "",
              );
              params.set("postLoginRedirectionUrl", currentUrl);
              navigate(`${pathname}?${params.toString()}`, { replace: true });
              signIn({ postLoginRedirectionUrl: currentUrl });
            }}
          >
            {t("common.error.login")}
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => {
              navigateLocale(`/${locale}`);
            }}
          >
            {t("common.error.go_to_home_page")}
          </Button>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
